// extracted by mini-css-extract-plugin
module.exports = {"full_screen_msg":"Loding_full_screen_msg__T8bio","fullPage":"Loding_fullPage__brJte"};